import {createContext} from 'react'

export const DialogContext = createContext(null)
export const DialogCloseContext = createContext(null)
